import AddressBook from './AddressBook';

export default AddressBook;
